import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import staticGameData from '../data/GameData';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import QuestionChoice from './QuestionChoice';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class QuestionDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    // Display
    this.bg = null;
    this.lblQuestion = null;
    this.lblNum1 = null;
    this.lblPlus = null;
    this.lblNum2 = null;
    this.lblNumQMark = null;

    this.choiceContainer = null;
    this.choiceDisplays = [];

    // Sounds
    this.correctSounds = [LocalizationSoundAssetKeys._CorrectSound, LocalizationSoundAssetKeys._RadicalSound, LocalizationSoundAssetKeys._SweetSound, LocalizationSoundAssetKeys._GotItSound, LocalizationSoundAssetKeys._GroovySound, LocalizationSoundAssetKeys._AwesomeSound];
    this.higherSounds = [LocalizationSoundAssetKeys._MoreThanSound, LocalizationSoundAssetKeys._TooLittleSound];
    this.lowerSounds = [LocalizationSoundAssetKeys._LessThanSound, LocalizationSoundAssetKeys._TooMuchSound];
    this.sentenceQueue = [];
    this.currentSentencePart = null;

    /** @type {Phaser.Sound.HTML5AudioSound | Phaser.Sound.WebAudioSound} */
    this.currentSound = null;

    // Data
    this.currentInfo = { answer: null, num1: null, num2: null, incorrects: 0 };

    /** @type {{ answer: any, num1: number, num2: number, incorrects: number }[]} */
    this.roundData = [];
    this.currentQuestion = 0;

    // Data/Arrays
    this.isEnabled = false;

    // Background
    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._mm_assets_QuestionBubble, this).setOrigin(0);

    // Question text pieces
    const lblY = 24;
    this.lblQuestion = ABCyaPhaser.Text.addText(30, lblY, 38, 0x000000, FontKeys._BPreplay_Bold, 'How many is ', this, false).setOrigin(0);
    this.lblNum1 = ABCyaPhaser.Text.addText(0, lblY, 38, 0xC1272D, FontKeys._BPreplay_Bold, 'Num1', this, false).setOrigin(0);
    this.lblPlus = ABCyaPhaser.Text.addText(0, lblY, 38, 0x000000, FontKeys._BPreplay_Bold, 'plus', this, false).setOrigin(0);
    this.lblNum2 = ABCyaPhaser.Text.addText(0, lblY, 38, 0xC1272D, FontKeys._BPreplay_Bold, 'Num2', this, false).setOrigin(0);
    this.lblNumQMark = ABCyaPhaser.Text.addText(0, lblY, 38, 0x000000, FontKeys._BPreplay_Bold, '?', this, false).setOrigin(0);

    // Choices
    this.choiceContainer = this.scene.add.container();
    for (let i = 0; i < 3; i++) {
      const item = new QuestionChoice(this.scene);
      item.x = 150 * i;
      item.on('CHOICE_SELECT', this.handleChoiceClick, this);
      this.choiceDisplays.push(item);
      this.choiceContainer.add(item);
    }
    this.choiceContainer.y = 130;
    this.choiceContainer.x = 110;
    this.add(this.choiceContainer);

    this.once(Phaser.GameObjects.Events.DESTROY, () => this.currentSound?.destroy());
  }

  /**
   * 
   * @param {QuestionChoice} questionChoice 
   * @returns 
   */
  handleChoiceClick (questionChoice) {
    if (!this.isEnabled) return;
    if (this.currentSound) {
      this.currentSound.removeAllListeners();
      this.currentSound.stop();
      this.currentSound.destroy();
    }

    this.currentSound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.currentSentencePart = null;
    this.sentenceQueue = [];
    if (questionChoice.num === this.currentInfo.answer) {
      this.roundData.push(this.currentInfo);
      this.isEnabled = false;
      ABCyaPhaser.Audio.playSound(this.correctSounds[Phaser.Math.Between(0, this.correctSounds.length - 1)], this.currentSound);
      if (this.currentQuestion < gameData.ROUND_QUESTION_COUNT) {
        this.emit('SUBMIT_QUESTION', this.currentInfo);
        this.currentSound.on(Phaser.Sound.Events.COMPLETE, this.initQuestion, this);
      }
      else {
        this.emit('SUBMIT_ROUND', this.roundData);
      }
    }
    else {
      questionChoice.showIncorrect();
      this.emit('INCORRECT_ANSWER');
      if (questionChoice.num > this.currentInfo.answer) {
        ABCyaPhaser.Audio.playSound(this.lowerSounds[Phaser.Math.Between(0, 1)], this.currentSound);
      }
      else {
        ABCyaPhaser.Audio.playSound(this.higherSounds[Phaser.Math.Between(0, 1)], this.currentSound);
      }
      this.currentInfo.incorrects++;
    }
  }

  stopSounds () {
    if (this.currentSound) {
      this.currentSound.removeAllListeners();
      this.currentSound.destroy();
    }

    this.currentSound = null;
    this.currentSentencePart = null;
    this.sentenceQueue = [];
  }

  initQuestion () {
    this.currentQuestion++;
    const maxNum = staticGameData.currentRound * 5;
    const currentAnswer = Phaser.Math.Between(1, maxNum);
    const num1 = Phaser.Math.Between(1, currentAnswer);
    const num2 = currentAnswer - num1;
    const spaceWidth = 10;
    this.currentInfo = { answer: currentAnswer, num1, num2, incorrects: 0, questionNum: this.currentQuestion };
    const lblX = 110;
    this.lblQuestion.text = 'How many is';
    this.lblQuestion.x = lblX;
    this.lblNum1.text = this.currentInfo.num1.toString();
    this.lblNum1.x = this.lblQuestion.x + this.lblQuestion.width + spaceWidth;
    this.lblPlus.text = 'plus';
    this.lblPlus.x = this.lblNum1.x + this.lblNum1.width + spaceWidth;
    this.lblNum2.text = this.currentInfo.num2.toString();
    this.lblNum2.x = this.lblPlus.x + this.lblPlus.width + spaceWidth;
    this.lblNumQMark.text = '?';
    this.lblNumQMark.x = this.lblNum2.x + this.lblNum2.width + spaceWidth;

    this.sentenceQueue = [LocalizationSoundAssetKeys._HowManySound, `Sound${num1}`, LocalizationSoundAssetKeys._PlusSound, `Sound${num2}`];

    // shuffleArray
    const answers = [currentAnswer];
    let newNum;
    while (answers.length < 3) {
      newNum = Phaser.Math.Between(1, maxNum);
      if (answers.indexOf(newNum) === -1) answers.push(newNum);
    }
    const choiceNums = Phaser.Utils.Array.Shuffle(answers);
    const count = this.choiceDisplays.length;
    for (let i = 0; i < count; i++) {
      const thisNum = choiceNums[i];
      this.choiceDisplays[i].setChoice(thisNum);
    }
    this.isEnabled = true;

    this.emit('INIT_QUESTION', this.currentQuestion);
    this.playSentencePart();
  }

  playSentencePart () {
    this.currentSound?.destroy();
    if (this.sentenceQueue.length > 0) {
      const soundName = this.sentenceQueue.shift();
      this.currentSound = ABCyaPhaser.Audio.createSound(this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
      this.currentSentencePart = this.currentSound;
      this.currentSentencePart.on('complete', this.playSentencePart, this);
      ABCyaPhaser.Audio.playSound(soundName, this.currentSound);
    }
    else {
      this.currentSound = null;
    }
  }
}